import { Component } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/app.config';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AccountService } from '../../api/services';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, filter } from 'rxjs/operators';
import { Subscription, throwError } from 'rxjs';
import { ManageUserProfile } from '../../api/models';

@Component({
  selector: 'app-blank',
  templateUrl: './blank.component.html',
  styleUrls: [],
})
export class BlankComponent {
  private htmlElement!: HTMLHtmlElement;
  user: ManageUserProfile = {}
  options = this.settings.getOptions();

  public selectedLanguage: any = {
    language: 'ไทย',
    code: 'th',
    icon: '/assets/images/flag/icon-flag-th.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'ไทย',
      code: 'th',
      icon: '/assets/images/flag/icon-flag-th.svg',
    }
  ];

  constructor(private settings: CoreService,
    private translate: TranslateService,
    private accountService: AccountService,
    private router: Router) {
    this.htmlElement = document.querySelector('html')!;
     // Initialize project theme with options
     this.receiveOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.toggleDarkTheme(options);
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }

  login() {
    window.location.href = "auth/login";
  }
  ngOnInit(): void {
     this.getUserInfo();
  }
  async getUserInfo() {
    this.accountService.apiAccountMeprofileGet().subscribe(result => {
      this.user = result;
      
      
    })
  }
  async profile() {
    window.location.href = "user/profile";
  }
}
